// import React from 'react'

export const units = {
  m : {
    code: "m",
    short: "m2",
    displayCode: "common:unit.sq-meters",
    transform(val) { return Math.round(val * 10000 * 100) / 100; }
  },
  ha : {
    code: "ha",
    short: "ha",
    displayCode: "common:unit.hectars",
    transform(val) { return val; }
  },
  km : {
    code: "km",
    short: "km2",
    displayCode: "common:unit.sq-kilometers",
    transform(val) { return Math.round(val * 0.01 * 100) / 100 ; }
  }
}

